import axios from 'axios';
import {
    handle
} from 'redux-pack';
import { budgetContact } from './index';

// Actions
export const BUDGET_IS_LOADING = 'BUDGET_IS_LOADING';
export const BUDGET_HAS_ERROR = 'BUDGET_HAS_ERROR';
export const BUDGET_UPDATE = 'BUDGET_UPDATE';
export const BUDGET_FORM_SUBMIT = 'BUDGET_FORM_SUBMIT';

// Default State
const initialState = {
    isLoading: false,
    hasError: false
};

export const budgetContactSubmit = (token, data) => ({
    type: BUDGET_FORM_SUBMIT,
    promise: axios({
        url: budgetContact,
        method: 'POST',
        data,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
});

export default (state = initialState, action = {}) => {
    const {
        type,
        response,
        isLoading,
        hasError
    } = action;

    switch (type) {
        case BUDGET_FORM_SUBMIT:
            return handle(state, action, {
                start: prevState => ({
                    ...prevState,
                    isLoading: true
                }),
                success: (prevState, { payload: token }) => ({
                    ...prevState,
                    token,
                    hasError: false
                }),
                failure: prevState => ({
                    ...prevState,
                    hasError: true
                }),
                finish: prevState => ({
                    ...prevState,
                    isLoading: false
                })
            });
        case BUDGET_IS_LOADING:
            return {
                ...state,
                isLoading
            };
        case BUDGET_HAS_ERROR:
            return {
                ...state,
                hasError
            };
        case BUDGET_UPDATE:
            return {
                ...state,
                ...response
            };
        default:
            return state;
    }
}
